module.exports = __webpack_public_path__ + "static/media/2.77eb2aa4.jpg";